module.exports = __webpack_public_path__ + "static/media/logo.2453b7b7.png";